import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isNil } from 'lodash';
import { message } from 'antd';

import moment from '../../lib/moment';
import OrderManagementListWrap from '../../views/order/management/list/OrderManagementListWrap';
import { orderActions } from '../../store/modules/order';
import { ORDER_MANAGEMENT_LIST_MODEL } from '../../store/modules/order/models';
import {
  INVALID_REQUIRED_SELECT_ORDER_ITEM_MESSAGE,
  INVALID_SPLIT_DOWNLOAD_PERIOD,
} from '../../constants/service/invalidMsg/orderInvalidMsg';
import {
  ENABLE_BULK_DELIVERY_INO_ORDER_ITEM_STATUS_LIST,
  ENABLE_CANCEL_SALES_ORDER_ITEM_STATUS_LIST,
  ENABLE_DELIVERY_DELAY_ORDER_ITEM_STATUS_LIST,
  ENABLE_DELIVERY_DISPATCH_ORDER_ITEM_STATUS_LIST,
  ENABLE_EDIT_BUYER_INFO_ORDER_ITEM_STATUS_LIST,
  ORDER_DELIVERY_TYPE,
  ORDER_GIFT_STATUS,
  ORDER_ITEM_STATUS,
  ORDER_PROCESS_AVAILABLE_GIFT_STATUS_LIST,
  ORDER_TYPE,
} from '../../constants/service/app/orderConstants';
import { asyncSimpleModal, checkIsNonSelectedList } from '../../lib/common';
import { setDeliveryInfo } from '../../lib/utils/orderutils';

class OrderManagementListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  initiate = () => {
    const { setData } = this.props;

    /**
     *  주문/배송관리 리스트 초기화
     */
    setData({
      path: ['orderManagementList'],
      value: ORDER_MANAGEMENT_LIST_MODEL,
    });
  };

  getList = (data) => {
    const { getOrderManagementList, orderManagementList } = this.props;
    const { searchOption, filterOption, pagination } = orderManagementList;

    getOrderManagementList({
      searchOption,
      filterOption,
      pagination,
      ...data,
    });
  };

  /**
   * 상품 준비처리하기
   * [결제 완료(3)]
   */
  deliveryPreparation = async () => {
    const { orderManagementList, deliveryPreparation } = this.props;
    const { list = [], selectedOrderItemList = [] } = orderManagementList;

    /**
     * 선택된 상품 주문서가 있는지 체크
     */
    const isSelected = checkIsNonSelectedList(selectedOrderItemList, INVALID_REQUIRED_SELECT_ORDER_ITEM_MESSAGE);
    if (!isSelected) return;

    /**
     *  상품 주문 상태가 결제 완료(3)이고
     *  선물인 경우 선물 상태가 선물 수락(1)인 경우에만
     *  상품 준비 처리를 할 수 있음
     */
    let targetOrderItemList = list.filter(
      (item) =>
        selectedOrderItemList.includes(item.id) &&
        item.orderItemStatus === ORDER_ITEM_STATUS.PAYMENT_COMPLETE &&
        (item.orderType === ORDER_TYPE.GENERAL ||
          (item.orderType === ORDER_TYPE.GIFT && item.giftStatus === ORDER_GIFT_STATUS.ACCEPT)),
    );

    /**
     *  선택한 상품 주문서에 결제 완료된 건이 없을 경우
     */
    if (!targetOrderItemList.length) {
      await asyncSimpleModal({
        type: 'error',
        title: '상품 준비',
        message: '선택한 주문은 상품 준비(발주확인)를 할 수 없습니다.',
      });
      return;
    }

    /**
     *  선택한 상품 주문서에 결제 완료된 건이 있을 경우
     *  확인을 누르면, 진행을 하고, 취소를 누르면 진행을 하지 않는다.
     */
    const deliveryPreparationConfirmResult = await asyncSimpleModal({
      type: 'confirm',
      title: '상품 준비',
      message:
        `선택하신 (${selectedOrderItemList.length}개) 상품 주문건 증 상품 준비(발주확인)\n` +
        `처리가 가능한 상품 주문은 (${targetOrderItemList.length}개)입니다.\n` +
        '진행하시겠습니까?',
      okText: '상품 준비',
    });

    /**
     *  선택된 결제 완료된 상품 리스트를
     *  서버로 전송해서 상품 준비 상태로 업데이트를 함
     */
    if (deliveryPreparationConfirmResult) {
      deliveryPreparation({
        orderItemIdList: targetOrderItemList.map((item) => item.id),
      });
    }
  };

  /**
   * 배송 지연처리하기
   * [결제 완료(3), 상품 준비(4)]
   */
  deliveryDelay = async () => {
    const { orderManagementList, toggleModal } = this.props;
    const { selectedOrderItemList = [], list = [] } = orderManagementList;

    /**
     * 선택된 상품 주문서가 있는지 체크
     */
    const isSelected = checkIsNonSelectedList(selectedOrderItemList, INVALID_REQUIRED_SELECT_ORDER_ITEM_MESSAGE);
    if (!isSelected) return;

    /**
     *  상품 주문 상태가 결제 완료(3) 상품 준비(4)이고
     *  선물인 경우 선물 상태가 선물 수락(1)인 경우에만
     *  상품 준비 처리를 할 수 있음
     */
    let targetOrderItemList = list.filter(
      (item) =>
        selectedOrderItemList.includes(item.id) &&
        ENABLE_DELIVERY_DELAY_ORDER_ITEM_STATUS_LIST.includes(item.orderItemStatus) &&
        (item.orderType === ORDER_TYPE.GENERAL ||
          (item.orderType === ORDER_TYPE.GIFT && item.giftStatus === ORDER_GIFT_STATUS.ACCEPT)),
    );

    /**
     *  선택한 상품 주문서에 결제 완료된 건이 없을 경우
     */
    if (!targetOrderItemList.length) {
      await asyncSimpleModal({
        type: 'error',
        title: '배송 지연',
        message: '선택한 주문은 배송 지연처리를 할 수 없습니다.',
      });
      return;
    }

    /**
     *  선택한 상품 주문서에 결제 완료된 건이 있을 경우
     *  확인을 누르면, 진행을 하고, 취소를 누르면 진행을 하지 않는다.
     */
    const deliveryDelayConfirmResult = await asyncSimpleModal({
      type: 'confirm',
      title: '배송 지연',
      message:
        `선택하신 (${selectedOrderItemList.length}개) 상품 주문건 증 배송 지연처리가\n` +
        `가능한 상품 주문은 (${targetOrderItemList.length}개)입니다.\n` +
        '진행하시겠습니까?',
      okText: '배송 지연',
    });

    /**
     *  배송 지연처리를 위해서 배송 지연 사유와 발송기한, 배송 지연 상세 사유를
     *  입력하는 모달을 열도록 함
     */
    if (deliveryDelayConfirmResult) {
      toggleModal({
        name: 'deliveryDelayModal',
        data: {
          orderItemIdList: targetOrderItemList.map((item) => item.id),
        },
      });
    }
  };

  /**
   * 발송처리하기
   * [상품 준비(4), 배송 지연(5)]
   */
  checkDeliveryDispatch = async () => {
    const { orderManagementList, checkDeliveryDispatch } = this.props;
    const { list = [], selectedOrderItemList = [] } = orderManagementList;

    /**
     * 선택된 상품 주문서가 있는지 체크
     */
    const isSelected = checkIsNonSelectedList(selectedOrderItemList, INVALID_REQUIRED_SELECT_ORDER_ITEM_MESSAGE);
    if (!isSelected) return;

    /**
     *  상품 주문 상태가 상품 준비(4), 배송 지연(5)이고
     *  선물인 경우 선물 상태가 선물 수락(1)인 경우에만
     *  발송처리를 할 수 있음
     */
    let targetOrderItemList = list.filter(
      (item) =>
        selectedOrderItemList.includes(item.id) &&
        ENABLE_DELIVERY_DISPATCH_ORDER_ITEM_STATUS_LIST.includes(item.orderItemStatus) &&
        (item.orderType === ORDER_TYPE.GENERAL ||
          (item.orderType === ORDER_TYPE.GIFT && item.giftStatus === ORDER_GIFT_STATUS.ACCEPT)),
    );

    /**
     *  선택한 상품 주문서에 상품 준비(4), 배송 지연(5) 건이 없을 경우
     */
    if (!targetOrderItemList.length) {
      await asyncSimpleModal({
        type: 'error',
        title: '발송처리',
        message: '선택한 주문은 발송처리를 할 수 없습니다.',
      });
      return;
    }

    /**
     *  배송 방법이 [택배, 등기, 소포]일 때는 택배사, 송장번호를 모두 다 입력이 되었는지 확인
     *  배송 방법이 그 이외일 때는 택배 방법만 입력이 되었는지 확인을 함
     *  여기에서 한개의 주문서가 위의 조건에 맞지 않을 경우 발송처리를 하지 않음.
     */
    const isInValidDeliveryInfo = targetOrderItemList.find((item) => {
      /**
       *  배송 방법이 택배, 등기, 소포인 경우
       */
      if (item.deliveryType === ORDER_DELIVERY_TYPE.PARCEL_DELIVERY) {
        if (!item.deliveryAgentId || !item.invoiceNumber || item.invoiceNumber === '') {
          return true;
        }
      } else if (isNil(item.deliveryType)) return true;
      /**
       *  배송 방법이 입력되지 않은 경우
       */
    });

    /**
     *  배송 방법, 택배사, 송장번호의 정보가 올바르지 않은 경우
     *  상품 주문을 발송처리를 할 수 없음
     */
    if (isInValidDeliveryInfo) {
      await asyncSimpleModal({
        type: 'error',
        title: '발송처리',
        message: '배송 방법, 택배사, 송장번호의 누락이 있습니다.',
      });
      return;
    }

    /**
     *  확인을 누르면, 진행을 하고, 취소를 누르면 진행을 하지 않는다.
     */
    const deliveryDispatchConfirmResult = await asyncSimpleModal({
      type: 'confirm',
      title: '발송처리',
      message:
        `선택하신 (${selectedOrderItemList.length}개) 상품 주문건 증 발송처리가\n` +
        `가능한 상품 주문은 (${targetOrderItemList.length}개)입니다.\n` +
        '진행하시겠습니까?',
      okText: '발송 처리',
    });

    /**
     *  발송처리하기 전에 유효성 체크 api 를 거치게 된다.
     */
    if (deliveryDispatchConfirmResult) {
      checkDeliveryDispatch({
        /**
         *  배송 정보 상품 주문서 리스트
         */
        deliveryInfoOrderItemList: targetOrderItemList.map((item) => ({
          /**
           *  상품 주문 id
           */
          orderItemId: item.orderItemId,
          /**
           *  배송 방법
           */
          deliveryType: item.deliveryType,
          /**
           *  택배사 id
           */
          deliveryAgentId: item.deliveryType === ORDER_DELIVERY_TYPE.PARCEL_DELIVERY ? item.deliveryAgentId : null,
          /**
           *  송장번호
           */
          invoiceNumber: item.deliveryType === ORDER_DELIVERY_TYPE.PARCEL_DELIVERY ? item.invoiceNumber : null,
        })),
      });
    }
  };

  /**
   * 송장정보 변경 callback
   */
  onChangeDeliveryInfo = (data) => {
    const { setData, orderManagementList } = this.props;
    let targetData = {
      ...orderManagementList.registerDeliveryInfo,
      ...data,
    };

    targetData = setDeliveryInfo(targetData);

    setData({
      path: ['orderManagementList', 'registerDeliveryInfo'],
      value: targetData,
    });
  };

  /**
   * 송장정보 일괄입력
   * [상품 준비(4), 배송 지연(5), 배송 중(6)]
   */
  applyBulkDeliveryInfo = () => {
    const { orderManagementList, setData } = this.props;
    const { list = [], registerDeliveryInfo, selectedOrderItemList = [] } = orderManagementList;
    const { deliveryType, deliveryAgentId, invoiceNumber } = registerDeliveryInfo;

    /**
     * 선택된 상품 주문서가 있는지 체크
     */
    const isSelected = checkIsNonSelectedList(selectedOrderItemList, '상품 주문을 선택해주세요.');
    if (!isSelected) return;

    const targetOrderItemList = list.filter((item) => selectedOrderItemList.includes(item.id));
    targetOrderItemList.forEach((item) => {
      /**
       *  - 상품 주문 상태가 상품 준비(4), 배송 지연(5), 배송 중(6)인 경우에만
       *  송장정보 일괄입력 기능을 사용할 수 잇음
       */
      if (ENABLE_BULK_DELIVERY_INO_ORDER_ITEM_STATUS_LIST.includes(item.orderItemStatus)) {
        /**
         *  해당 상품 index
         */
        const index = list.findIndex((orderItem) => orderItem.id === item.id);
        const updateData = {
          deliveryType: null,
          deliveryAgentId: null,
          invoiceNumber: null,
        };

        /**
         *  배송방법
         */
        if (!isNil(deliveryType)) updateData.deliveryType = deliveryType;

        /**
         *  배송방법 === 택배, 등기, 소포
         */
        if (deliveryType === ORDER_DELIVERY_TYPE.PARCEL_DELIVERY) {
          /**
           *  택배사
           */
          if (deliveryAgentId) updateData.deliveryAgentId = deliveryAgentId;

          /**
           *  송장번호
           */
          if (invoiceNumber) updateData.invoiceNumber = invoiceNumber;
        }

        setData({
          path: ['orderManagementList', 'list', index],
          value: {
            ...item,
            ...updateData,
          },
        });
      }
    });
  };

  /**
   * 상품 주문서 선택 callback
   */
  onCheckOrderItem = (list) => {
    const { setData } = this.props;
    setData({
      path: ['orderManagementList', 'selectedOrderItemList'],
      value: list,
    });
  };

  /**
   * 엑셀 일괄 배송처리
   */
  excelBulkDeliveryDispatch = () => {
    const { toggleModal } = this.props;

    toggleModal({
      name: 'excelBulkDeliveryDispatchModal',
    });
  };

  /**
   * 판매 취소하기
   * [결제 완료(3), 상품 준비(4), 배송 지연(5)]
   */
  cancelSales = async () => {
    const { orderManagementList, toggleModal } = this.props;
    const { list = [], selectedOrderItemList = [] } = orderManagementList;

    /**
     * 선택된 상품 주문서가 있는지 체크
     */
    const isSelected = checkIsNonSelectedList(selectedOrderItemList, INVALID_REQUIRED_SELECT_ORDER_ITEM_MESSAGE);
    if (!isSelected) return;

    /**
     *  상품 주문 상태가 결제 완료(3), 상품 준비(4), 배송 지연(5)이고
     *  선물인 경우 선물 상태가 선물 수락 대기(0), 선물 수락(1)인 경우에만
     *  주문자 정보 수정이 가능함
     */
    let targetOrderItemList = list.filter(
      (item) =>
        selectedOrderItemList.includes(item.id) &&
        ENABLE_CANCEL_SALES_ORDER_ITEM_STATUS_LIST.includes(item.orderItemStatus) &&
        (item.orderType === ORDER_TYPE.GENERAL ||
          (item.orderType === ORDER_TYPE.GIFT && ORDER_PROCESS_AVAILABLE_GIFT_STATUS_LIST.includes(item.giftStatus))),
    );

    /**
     *  선택한 상품 주문서에 결제 완료(3), 상품 준비(4), 배송 지연(5) 건이 없을 경우
     */
    if (!targetOrderItemList.length) {
      await asyncSimpleModal({
        type: 'error',
        title: '판매 취소',
        message: '해당 상품 주문은 판매 취소를\n' + '할 수 없습니다.',
      });
      return;
    }

    /**
     *  선택한 상품 주문서에 결제 완료된 건이 있을 경우
     *  확인을 누르면, 진행을 하고, 취소를 누르면 진행을 하지 않는다.
     */
    const cancelSalesConfirmResult = await asyncSimpleModal({
      type: 'confirm',
      title: '판매 취소',
      message:
        `선택하신 (${selectedOrderItemList.length}개) 상품 주문건 증 판매 취소\n` +
        `처리가 가능한 상품 주문은 (${targetOrderItemList.length}개)입니다.\n` +
        '진행하시겠습니까?',
      okText: '판매 취소',
    });

    /**
     *  판매 취소처리를 위해서 판매 취소 사유와 판매 취소 상세 사유를
     *  입력하는 모달을 열도록 함
     */
    if (cancelSalesConfirmResult) {
      toggleModal({
        name: 'cancelSalesModal',
        data: {
          orderItemIdList: targetOrderItemList.map((item) => item.id),
        },
      });
    }
  };

  /**
   * 주문자 정보 수정
   * [입금 대기(2), 결제 완료(3), 상품 준비(4), 배송 지연(5)]
   */
  editBuyerInfo = async () => {
    const { orderManagementList, toggleModal } = this.props;
    const { list, selectedOrderItemList } = orderManagementList;

    /**
     * 선택된 상품 주문서가 있는지 체크
     */
    const isSelected = checkIsNonSelectedList(selectedOrderItemList, INVALID_REQUIRED_SELECT_ORDER_ITEM_MESSAGE);
    if (!isSelected) return;

    /**
     *  주문자 정보 수정은 1 건씩만 가능합니다.
     */
    if (selectedOrderItemList.length > 1) {
      await asyncSimpleModal({
        type: 'error',
        title: '주문자 정보 수정',
        message: '주문자 정보 수정은 1건씩만 가능합니다.',
      });
      return;
    }

    /**
     *  상품 주문 상태가 입금 대기(2) 결제 완료(3) 상품 준비(4), 배송 지연(5)이고
     *  선물인 경우 선물 상태가 선물 수락 대기(0), 선물 수락(1)인 경우에만
     *  주문자 정보 수정이 가능함
     */
    const targetOrderItemList = list.filter((item) => selectedOrderItemList.includes(item.id));
    const targetOrderItem = targetOrderItemList.find(
      (item) =>
        ENABLE_EDIT_BUYER_INFO_ORDER_ITEM_STATUS_LIST.includes(item.orderItemStatus) &&
        (item.orderType === ORDER_TYPE.GENERAL ||
          (item.orderType === ORDER_TYPE.GIFT && ORDER_PROCESS_AVAILABLE_GIFT_STATUS_LIST.includes(item.giftStatus))),
    );

    /**
     *  선택한 상품 주문서에 입금 대기(2) 결제 완료(3) 상품 준비(4) 배송 지연(5)건이 없을 경우
     */
    if (!targetOrderItem) {
      await asyncSimpleModal({
        type: 'error',
        title: '주문자 정보 수정',
        message: '해당 상품 주문은 주문자 정보 수정이\n' + '불가능한 상태입니다.',
      });
      return;
    }

    /**
     *  주문자 정보를 수정할 수 있는 모달을 열도록 함
     */
    toggleModal({
      name: 'editBuyerInfoModal',
      data: {
        orderItemId: targetOrderItem.orderItemId,
        isGiftReady:
          targetOrderItem.orderType === ORDER_TYPE.GIFT && targetOrderItem.giftStatus === ORDER_GIFT_STATUS.READY,
        recipientName: targetOrderItem.recipientName,
        recipientPhone: targetOrderItem.recipientPhone,
        address: {
          postCode: targetOrderItem.shippingPostCode,
          line1: targetOrderItem.shippingAddress1,
          line2: targetOrderItem.shippingAddress2,
        },
        shippingMessage: targetOrderItem.shippingMessage,
      },
    });
  };

  /**
   * 송장 수정하기
   * [배송 중(6)]
   */
  editDeliveryInfo = async () => {
    const { orderManagementList, editDeliveryInfo } = this.props;
    const { list, selectedOrderItemList } = orderManagementList;

    /**
     * 선택된 상품 주문서가 있는지 체크
     */
    const isSelected = checkIsNonSelectedList(selectedOrderItemList, INVALID_REQUIRED_SELECT_ORDER_ITEM_MESSAGE);
    if (!isSelected) return;

    /**
     *  상품 주문 상태가 배송 중(6)이고
     *  선물인 경우 선물 상태가 선물 수락(1)인 경우에만
     *  송장 수정을 할 수 있음
     */
    let targetOrderItemList = list.filter(
      (item) =>
        selectedOrderItemList.includes(item.id) &&
        item.orderItemStatus === ORDER_ITEM_STATUS.SHIPPING &&
        (item.orderType === ORDER_TYPE.GENERAL ||
          (item.orderType === ORDER_TYPE.GIFT && item.giftStatus === ORDER_GIFT_STATUS.ACCEPT)),
    );

    /**
     *  선택한 상품 주문서에 배송 중(6) 건이 없을 경우
     */
    if (!targetOrderItemList.length) {
      await asyncSimpleModal({
        type: 'error',
        title: '송장 수정',
        message: '선택한 주문은 송장 수정을 할 수 없습니다.',
      });
      return;
    }

    /**
     *  배송 방법이 [택배, 등기, 소포]일 때는 택배사, 송장번호를 모두 다 입력이 되었는지 확인
     *  배송 방법이 그 이외일 때는 택배 방법만 입력이 되었는지 확인을 함
     *  여기에서 한개의 주문서가 위의 조건에 맞지 않을 경우 발송처리를 하지 않음.
     */
    const isInValidDeliveryInfo = targetOrderItemList.find((item) => {
      /**
       *  배송 방법이 택배, 등기, 소포인 경우
       */
      if (item.deliveryType === ORDER_DELIVERY_TYPE.PARCEL_DELIVERY) {
        if (!item.deliveryAgentId || !item.invoiceNumber || item.invoiceNumber === '') {
          return true;
        }
      } else if (isNil(item.deliveryType)) return true;
      /**
       *  배송 방법이 입력되지 않은 경우
       */
    });

    /**
     *  배송 방법, 택배사, 송장번호의 정보가 올바르지 않은 경우
     *  상품 주문을 발송처리를 할 수 없음
     */
    if (isInValidDeliveryInfo) {
      await asyncSimpleModal({
        type: 'error',
        title: '발송처리',
        message: '배송 방법, 택배사, 송장번호의 누락이 있습니다.',
      });
      return;
    }

    /**
     *  확인을 누르면, 진행을 하고, 취소를 누르면 진행을 하지 않는다.
     */
    const editDeliveryInfoConfirmResult = await asyncSimpleModal({
      type: 'confirm',
      title: '발송처리',
      message:
        `선택하신 (${selectedOrderItemList.length}개) 상품 주문건 증 송장수정이\n` +
        `가능한 상품 주문은 (${targetOrderItemList.length}개)입니다.\n` +
        '진행하시겠습니까?',
      okText: '발송 처리',
    });

    /**
     *  송장 수정하기
     */
    if (editDeliveryInfoConfirmResult) {
      editDeliveryInfo({
        /**
         *  상품 주문서 리스트
         */
        orderItemList: targetOrderItemList.map((item) => ({
          /**
           *  상품 주문 id
           */
          orderItemId: item.orderItemId,
          /**
           *  배송 방법
           */
          deliveryType: item.deliveryType,
          /**
           *  택배사 id
           */
          deliveryAgentId: item.deliveryType === ORDER_DELIVERY_TYPE.PARCEL_DELIVERY ? item.deliveryAgentId : null,
          /**
           *  송장번호
           */
          invoiceNumber: item.deliveryType === ORDER_DELIVERY_TYPE.PARCEL_DELIVERY ? item.invoiceNumber : null,
        })),
      });
    }
  };

  /**
   *  전체 엑셀 다운로드
   */
  getAllManagementListExcelDownLoad = ({ split }) => {
    const { orderManagementList, getAllManagementListExcelDownLoad, adminInfo } = this.props;
    const { searchOption, filterOption } = orderManagementList;

    /**
     * 브랜드 분할 다운로드는 서버 리소스를 많이 차지하여 주문갯수를 일정 범위로 제한하기 위해 날짜가 설정되어 있지 않거나, 날짜 범위가 7일보다 크면 동작하지 않음
     */
    if (split) {
      if (!searchOption.viewPeriod.period.startDate || !searchOption.viewPeriod.period.endDate) {
        message.error(INVALID_SPLIT_DOWNLOAD_PERIOD);
        return;
      }

      if (
        Math.abs(
          moment(searchOption.viewPeriod.period.startDate).diff(searchOption.viewPeriod.period.endDate, 'days'),
        ) > 7
      ) {
        message.error(INVALID_SPLIT_DOWNLOAD_PERIOD);
        return;
      }
    }

    getAllManagementListExcelDownLoad({
      split,
      email: adminInfo.email,
      fileName: '주문/배송관리 전체 리스트',
      searchOption,
      filterOption,
    });
  };

  /**
   *  선택 엑셀 다운로드
   */
  getSelectedManagementListExcelDownLoad = ({ split }) => {
    const { orderManagementList, getSelectedManagementListExcelDownLoad, adminInfo } = this.props;
    const { searchOption, filterOption, selectedOrderItemList = [] } = orderManagementList;

    if (!selectedOrderItemList.length) {
      message.error(INVALID_REQUIRED_SELECT_ORDER_ITEM_MESSAGE);
      return;
    }

    /**
     * 브랜드 분할 다운로드는 서버 리소스를 많이 차지하여 주문갯수를 일정 범위로 제한하기 위해 날짜가 설정되어 있지 않거나, 날짜 범위가 7일보다 크면 동작하지 않음
     */
    if (split) {
      if (!searchOption.viewPeriod.period.startDate || !searchOption.viewPeriod.period.endDate) {
        message.error(INVALID_SPLIT_DOWNLOAD_PERIOD);
        return;
      }

      if (
        Math.abs(
          moment(searchOption.viewPeriod.period.startDate).diff(searchOption.viewPeriod.period.endDate, 'days'),
        ) > 7
      ) {
        message.error(INVALID_SPLIT_DOWNLOAD_PERIOD);
        return;
      }
    }

    getSelectedManagementListExcelDownLoad({
      split,
      email: adminInfo.email,
      fileName: '주문/배송관리 선택 리스트',
      selectedOrderItemList,
      searchOption,
      filterOption,
    });
  };

  render() {
    const { orderManagementList, setData } = this.props;

    return (
      <OrderManagementListWrap
        orderManagementList={orderManagementList}
        setData={setData}
        getList={this.getList}
        deliveryPreparation={this.deliveryPreparation}
        deliveryDelay={this.deliveryDelay}
        checkDeliveryDispatch={this.checkDeliveryDispatch}
        onChangeDeliveryInfo={this.onChangeDeliveryInfo}
        applyBulkDeliveryInfo={this.applyBulkDeliveryInfo}
        onCheckOrderItem={this.onCheckOrderItem}
        excelBulkDeliveryDispatch={this.excelBulkDeliveryDispatch}
        cancelSales={this.cancelSales}
        editBuyerInfo={this.editBuyerInfo}
        editDeliveryInfo={this.editDeliveryInfo}
        getAllManagementListExcelDownLoad={this.getAllManagementListExcelDownLoad}
        getSelectedManagementListExcelDownLoad={this.getSelectedManagementListExcelDownLoad}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminInfo: state.app.adminInfo,
    orderManagementList: state.order.orderManagementList,
  };
};

const mapDispatchToProps = {
  setData: orderActions.setData,
  getOrderManagementList: orderActions.getOrderManagementList,
  deliveryPreparation: orderActions.deliveryPreparation,
  checkExcelBulkDeliveryDispatch: orderActions.checkExcelBulkDeliveryDispatch,
  checkDeliveryDispatch: orderActions.checkDeliveryDispatch,
  editDeliveryInfo: orderActions.editDeliveryInfo,
  getAllManagementListExcelDownLoad: orderActions.getAllManagementListExcelDownLoad,
  getSelectedManagementListExcelDownLoad: orderActions.getSelectedManagementListExcelDownLoad,
  toggleModal: orderActions.toggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderManagementListContainer);
